import { SideMenu } from "../models/SideMenu";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { EngineeringRounded, HomeRounded } from "@mui/icons-material";

export const ConsultantMenu: SideMenu[] = [
    {
        label: "Dashboard",
        icon: HomeRounded,
        link: "/consultant-dashboard"
    },
    {
        label: "Consultant Profile",
        icon: EngineeringRounded,
        link: "/consultant-view"
    },
    {
        label: "Clients",
        icon: PersonRoundedIcon,
        link: "/client-table"
    }
];
